module.exports = __webpack_public_path__ + "media/images/icons/icon-close-b3622085a14013fa4f7b80fd7ab6f4d6.svg";